import { createActionNamespace } from 'Modules/core/redux';


const cryptoprofilesAction = createActionNamespace('cryptoprofiles');


export const cryptoprofilesActions = {
    init: cryptoprofilesAction('INIT'),
    load: cryptoprofilesAction('LOAD'),
    registerCert: cryptoprofilesAction('REGISTER_CERT'),
    remove: cryptoprofilesAction('REMOVE'),
};
